module.exports = __webpack_public_path__ + "static/media/add award category.5cd35479.svg";